import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const truckTypeParamsSchema = object({
  truckTypeId: stringToNumber()
})
